<template>
    <div class="appointments">
        <div class="container-fluid">
            <div class="row">
                <Menu title="Appointments" />
                <div class="col-12 p-0"> 
                    <Appointment id="appoint_view" 
                    :style="{
                        width : !$store.state.menu_toggle ? 'calc(100% - 70px)' : 'calc(100% - 255px )',
                    }" 
                    ></Appointment>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from '@/components/menu_component.vue';
    import Appointment from '@/components/appointments_component.vue';

    export default {
        name: 'appointment_view',
        data() {
            return {
            }
        },
        components: {
            Menu,
            Appointment
        }
    }
</script>